import { paths } from '@/app/router/paths';
import { RegisterInput } from '@/features/auth/validation/register-input.schema';
import { supabase } from '@/lib/supabase/config';
import { getDeeplinkPrefix } from '@/shared/utils/deeplink-prefix';

export const register = async (input: RegisterInput) => {
  let redirectTo = getDeeplinkPrefix();

  if (input.redirectTo && input.redirectTo.trim().length > 0) {
    // RedirectTo does not include the domain
    redirectTo += input.redirectTo;
  } else {
    redirectTo += paths.org.create.path;
  }

  const { data, error } = await supabase.auth.signUp({
    email: input.email,
    password: input.password,
    options: {
      data: {
        name: input.name,
      },
      emailRedirectTo: redirectTo,
    },
  });
  if (error) {
    throw error;
  }
  return data;
};
